import React, { useState, useEffect } from "react";
import { Button, Modal, ModalBody } from "@windmill/react-ui";
import getEmployeeId from "utils/commonAdmin";
import * as countryCodes from "country-codes-list";

const id_employee = getEmployeeId();

const countryCodeList = countryCodes.customList(
  "countryCallingCode",
  "{countryNameEn} ({countryCallingCode})"
);

const countryCodeOptions = Object.entries(countryCodeList).map(([code, name]) => ({
  code: code.startsWith("+") ? code : `+${code}`,
  name: name.split(" (")[0],
  label: `${name.split(" (")[0]} (${code.startsWith("+") ? code : `+${code}`})`,
}));

const defaultCountry = countryCodeOptions.find((country) => country.code === "+91") || countryCodeOptions[0];

const ClientSmsModal = ({
  isOpen,
  onClose,
  title = "Send Driver details to Customer",
  handleSubmit,
  disabled,
  isSubmitting,
  contactnumber,
  customClass = "",
}) => {
  const [mobileno, setMobileno] = useState("");
  const [error, setError] = useState("");
  const [selectedSmsOption, setSelectedSmsOption] = useState(1);
  const [selectedCountryCode, setSelectedCountryCode] = useState(defaultCountry.code);
  const [showCountryCode, setShowCountryCode] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setMobileno("");
      setError("");
      setSelectedCountryCode(defaultCountry.code);
    }
    setMobileno(contactnumber || "");
  }, [isOpen, contactnumber]);

  useEffect(() => {
    setShowCountryCode(selectedSmsOption === 2);
  }, [selectedSmsOption]);

  const handleSubmitSms = () => {
    let numberToValidate = mobileno.trim();
    let countryCodeRaw = "";

    if (selectedSmsOption === 2) {
      countryCodeRaw = selectedCountryCode?.replace(/^\+/, "") || "";

      if (numberToValidate.startsWith(countryCodeRaw)) {
        numberToValidate = numberToValidate.slice(countryCodeRaw.length);
      }
    }

    if (!numberToValidate) {
      setError("Mobile Number is required!");
      return;
    }

    if (!/^[0-9]+$/.test(numberToValidate)) {
      setError("Mobile Number must contain only digits!");
      return;
    }

    if (numberToValidate.length !== 10) {
      setError("Mobile Number must be exactly 10 digits!");
      return;
    }

    setError("");

    const payload = {
      mobileno: numberToValidate,
      type: selectedSmsOption,
      id_employee,
      ...(selectedSmsOption === 2 && {
        contact_no_country_code: countryCodeRaw,
      }),
    };

    handleSubmit(payload);
  };

  const handleSmsChange = (e) => {
    setSelectedSmsOption(Number(e.target.value));
  };

  const handleCountryCodeChange = (e) => {
    setSelectedCountryCode(e.target.value);
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 10) {
      setMobileno(value);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className={`relative bg-white pb-0 p-4 w-1/3 rounded-lg ${customClass}`}
      aria-labelledby="modal-title"
    >
      <span id="modal-title" className="flex text-2xl text-black-500 ml-3">
        {title}
      </span>
      <ModalBody className="!mb-0 text-center custom-modal pt-3 pb-4">
        <div className="radio-input-wrapper flex items-center space-x-4">
          <label className="label pe-md-3 py-1 py-sm-2">
            <input
              type="radio"
              value={1}
              checked={Number(selectedSmsOption) === 1}
              onChange={handleSmsChange}
              className="radio-type me-1"
            />
            <span className="ml-2">SMS</span>
          </label>

          <label className="label pe-md-3 py-1 py-sm-2">
            <input
              type="radio"
              value={2}
              checked={Number(selectedSmsOption) === 2}
              onChange={handleSmsChange}
              className="radio-type me-1"
            />
            <span className="ml-2">WhatsApp</span>
          </label>
        </div>

        {showCountryCode && (
          <div className="mt-4">
            <label htmlFor="country-code" className="block text-sm font-medium text-gray-700 mb-1 text-left">
              Country Code
            </label>
            <select
              id="country-code"
              value={selectedCountryCode}
              onChange={handleCountryCodeChange}
              className="w-full border border-gray-300 rounded p-2"
            >
              {countryCodeOptions.map((country) => (
                <option key={country.code} value={country.code}>
                  {country.label}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="mt-4">
          <label htmlFor="phone-number" className="block text-sm font-medium text-gray-700 mb-1 text-left">
            Mobile Number
          </label>
          <div className="flex">
            {showCountryCode && (
              <div className="flex items-center justify-center px-3 border border-r-0 border-gray-300 rounded-l bg-gray-100">
                {selectedCountryCode}
              </div>
            )}
            <input
              id="phone-number"
              className={`w-full border border-gray-300 rounded${showCountryCode ? '-l-none rounded-r' : ''} p-2`}
              placeholder={showCountryCode ? "1234567890" : "Enter Mobile Number"}
              value={mobileno}
              type="number"
              autoComplete="off"
              maxLength={10}
              onChange={handlePhoneChange}
              style={{ height: "100%" }}
            />
          </div>
          {error && <p className="text-red-500 text-sm mt-2 text-left">{error}</p>}
        </div>

        <div className="flex items-center justify-around gap-4 mt-8">
          <Button
            onClick={handleSubmitSms}
            disabled={isSubmitting}
            className="bg-green-500 hover:bg-green-600 text-white w-full sm:w-auto"
          >
            Send
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ClientSmsModal;
